import React from 'react'
import { useField } from 'formik'
import { Form } from 'lib/ui/components'
import DatePicker from 'react-datepicker'
import { Container } from './styled'
import 'react-datepicker/dist/react-datepicker.css'

export const DatePickerInput = ({ label, isRequired, ...props }: any) => {
  const name = props.field.name
  const [field, meta, helper] = useField(props.field)
  const hasError = name && meta.error && meta.touched
  const value = field?.value

  return (
    <Form.Field
      hasError={false}
    >
      {label && (
        <Form.Label htmlFor={name}>
          <span>{label}</span>
          {isRequired && <em>*</em>}
        </Form.Label>
      )}

      <Container>
        <DatePicker
          selected={value ? new Date(value) : null}
          onChange={val => {
            helper.setValue(val)
          }}
        />
      </Container>

      {hasError && (
        <Form.Error>
          {meta.error}
        </Form.Error>
      )}
    </Form.Field>
  )
}
